import { makeStyles } from '@material-ui/core/styles';
import { redesignTheme } from '../theme';

const { spacing, sizes, colors, fonts, fontSize, breakpoints, radius } = redesignTheme;

export const useHomePageSharedStyles = makeStyles(() => ({
  sectionIntro: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    marginBottom: spacing.md,
    maxWidth: sizes.contentMaxWidthWide,
  },
  sectionLabel: {
    margin: 0,
    fontFamily: fonts.opensansBold,
    fontSize: fontSize.base,
    color: colors.primary,
    letterSpacing: 1.28,
    lineHeight: 'normal',
  },
  sectionTitle: {
    margin: 0,
    fontFamily: fonts.opensansBold,
    fontSize: fontSize.xxl,
    color: colors.textBody,
    lineHeight: 'normal',
    [`@media (max-width: ${breakpoints.mobile}px)`]: {
      fontSize: fontSize.xl,
    },
  },
  sectionDescription: {
    margin: 0,
    fontFamily: fonts.opensans,
    fontSize: fontSize.lg,
    color: colors.text,
    lineHeight: 'normal',
    [`@media (max-width: ${breakpoints.mobile}px)`]: {
      fontSize: fontSize.base,
    },
  },
  sectionWhite: {
    width: '100%',
    padding: `${spacing.lg}px ${spacing.sm}px`,
    borderRadius: `${radius.section}px ${radius.section}px 0 0`,
    backgroundColor: colors.white,
    boxSizing: 'border-box',
    [`@media (min-width: ${breakpoints.desktop}px)`]: {
      padding: '64px 80px',
    },
  },
  arrowIcon: {
    width: 16,
    height: 16,
    color: colors.primaryDark,
    fill: 'currentColor',
  },
  cardImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    display: 'block',
  },
  itemIconWrap: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 48,
    height: 48,
    borderRadius: radius.sm,
    backgroundColor: colors.iconMutedSurface,
    flexShrink: 0,
  },
  itemIcon: {
    width: 20,
    height: 20,
    color: colors.primaryDark,
  },
  itemTextBlock: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    minWidth: 0,
  },
  itemTitle: {
    margin: 0,
    fontFamily: fonts.opensansBold,
    fontSize: fontSize.base,
    color: colors.textBody,
    lineHeight: 'normal',
  },
  itemDescription: {
    margin: 0,
    fontFamily: fonts.opensansSemiBold,
    fontSize: fontSize.sm,
    color: colors.textSubtle,
    lineHeight: 'normal',
  },
}));
